var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code-wrapper",staticStyle:{"line-height":"0"}},[_c('vue-qrcode',{ref:"canvas",attrs:{"value":_vm.value,"type":"image/png","options":_vm.options},on:{"ready":_vm.onReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }